import { takeLatest, call, put, select } from 'redux-saga/effects'
import log from 'loglevel';

import axios from "../../utils/axios";
import getEnvParam from '../../utils/getEnvParam';
import messages from "../../assets/i18n";
import { SIM, NAO } from '../../utils/constants';
import { saveAs } from "file-saver";
import { requestDefaultJson } from './helpers'


const preSchedulingFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

const addFilter = (filter, filterName) => {
	if (filter) {
		return '&' + filterName + '=' + filter
	} else {
		return ''
	}
}

function* preSchedulingList(payload, token) {
	try {

        const { providerId } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    listarPreAgendamentosDoFornecedor (idFornecedor: ${providerId}) {
                        id
                        ativo
                        capacidade
                        cd {
                            id
                            nome
                        }
                        descricao
                        empresa {
                            id
                            nome
                            habilitarPreAgendamentoFornecedor
                        }
                        fornecedor {
                            id
                            nome
                        }
                        fusoHorario {
                            id
                            descricao
                        }
                        portao {
                            id
                            nome
                        }
                        horasDeTrabalho {
                            id
                            horaInicial
                            horaFinal
                            dataInicial
                            dataFinal
                            dataCadastro
                            dataModificacao
                            tipoHoraTrabalho {
                                id
                                descricao
                            }
                            
                        }
                        recebimentoCaixaria
                        recebimentoDeEncabidado
                        transferencia 
                    }
                }
            `
		};

		const { data } = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
        return error
	}
}

function* timeZones(token) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    listarFusoHorario {
                        id
                        descricao
                    }
                }
            `
		};

		const { data } = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* workHours(token) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    listarTiposHoraTrabalho {
                        id
                        descricao
                    }
                }
            `
		};

		const { data } = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* newPreScheduling(payload, token) {
	try {
        const { 
            ativo,
            transferencia,
            recebimentoDeEncabidado,
            recebimentoCaixaria,
            empresa,
            cd,
            descricao,
            capacidade,
            fusoHorario,
            dataInicial,
            dataFinal,
            horaInicial,
            horaFinal,
            tipoHoraTrabalho,
            fornecedor,
            diasDeTrabalho
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    criarPreAgendamento (
                        preAgendamentoInput: {
                            ativo: "${ativo === SIM ? SIM : NAO}"
                            transferencia: "${transferencia === SIM ? SIM : NAO}"
                            recebimentoDeEncabidado: "${recebimentoDeEncabidado === SIM ? SIM : NAO}"
                            recebimentoCaixaria: "${recebimentoCaixaria === SIM ? SIM : NAO}"
                            empresa: "${empresa}"
                            cd: ${cd}
                            descricao: "${descricao}"
                            capacidade: ${capacidade}
                            fusoHorario: ${fusoHorario}
                            fornecedor: ${fornecedor}
                        },
                        horaDeTrabalhoInput: {
                            dataInicial: "${dataInicial ? dataInicial : ""}"
                            dataFinal: "${dataFinal ? dataFinal : ""}"
                            horaInicial: "${horaInicial ? horaInicial : ""}"
                            horaFinal: "${horaFinal ? horaFinal : ""}"
                            tipoHoraTrabalho: ${tipoHoraTrabalho}
                            diasDeTrabalho: [${diasDeTrabalho}]
                        }                         
                    ){
                        id                        
                    }
                }
            `
		};

		const data = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
        return error
	}
}

function* editPreScheduling(payload, token) {
	try {
        const { 
            id,
            idHoraTrabalho,
            ativo,
            transferencia,
            recebimentoDeEncabidado,
            recebimentoCaixaria,
            empresa,
            cd,
            descricao,
            capacidade,
            fusoHorario,
            dataInicial,
            dataFinal,
            horaInicial,
            horaFinal,
            tipoHoraTrabalho,
            fornecedor,
            diasDeTrabalho
         } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                mutation {
                    atualizarPreAgendamento (
                        preAgendamentoInput: {
                            id: ${id}
                            ativo: "${ativo === SIM ? SIM : NAO}"
                            transferencia: "${transferencia === SIM ? SIM : NAO}"
                            recebimentoDeEncabidado: "${recebimentoDeEncabidado === SIM ? SIM : NAO}"
                            recebimentoCaixaria: "${recebimentoCaixaria === SIM ? SIM : NAO}"
                            empresa: "${empresa}"
                            cd: ${cd}
                            descricao: "${descricao}"
                            capacidade: ${capacidade}
                            fusoHorario: ${fusoHorario}
                            fornecedor: ${fornecedor}
                        },
                        horaDeTrabalhoInput: {
                            id: ${idHoraTrabalho}
                            dataInicial: "${dataInicial ? dataInicial : ""}"
                            dataFinal: "${dataFinal ? dataFinal : ""}"
                            horaInicial: "${horaInicial ? horaInicial : ""}"
                            horaFinal: "${horaFinal ? horaFinal : ""}"
                            tipoHoraTrabalho: ${tipoHoraTrabalho}
                            diasDeTrabalho: [${diasDeTrabalho}]
                        }                         
                    ){
                        id                        
                    }
                }
            `
		};

		const data = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* preSchedulingDetails(payload, token) {
	try {
        const { preSchedulingId } = payload

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    buscarPorId (idPreAgendamento: ${preSchedulingId}){
                        id  
                        ativo
                        capacidade
                        cd {
                            id
                            nome
                        }
                        descricao
                        empresa {
                            id
                            nome
                            habilitarPreAgendamentoFornecedor
                        }
                        fornecedor {
                            id
                            nome
                        }
                        fusoHorario {
                            id
                            descricao
                        }
                        portao {
                            id
                            nome
                        }
                        horasDeTrabalho {
                            id
                            horaInicial
                            horaFinal
                            dataInicial
                            dataFinal
                            dataCadastro
                            dataModificacao
                            tipoHoraTrabalho {
                                id
                                descricao
                            }
                            diasDeTrabalho {
                                diaSemana
                            }
                            
                        }
                        recebimentoCaixaria
                        recebimentoDeEncabidado
                        transferencia                       
                    }
                }
            `
		};

		const { data } = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getProviderPreSchedulingList(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
        yield put({ type: "SET_LOADING_PRE_SCHEDULING_LIST", payload: true });

		const result = yield call(preSchedulingList, payload.payload, token);
   
		if (result && result.listarPreAgendamentosDoFornecedor) {
            yield put({ type: "SET_PRE_SCHEDULING_LIST", payload: result.listarPreAgendamentosDoFornecedor});
        } else {
            yield put({ 
                type: "SET_PRE_SCHEDULING_TOAST", 
                payload: {
                    showToast: true,
                    message: `${result.data && result.data.error ? result.data.error : ''} - ${result.data && result.data.message ? result.data.message : ''} `,
                    messageType: "toast-error"
                }});
        }

        yield put({ type: "SET_LOADING_PRE_SCHEDULING_LIST", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getTimeZones(payload) {
	try {
		const { token } = yield select(state => state.authentication);
                
		const result = yield call(timeZones, token);
                          
		if (result && result.listarFusoHorario) {
            yield put({ type: "SET_TIME_ZONE_LIST", payload: result.listarFusoHorario});
        }
	} catch (error) {
		log.info(error);
	}
}

function* getWorkHourTypes(payload) {
	try {
		const { token } = yield select(state => state.authentication);
        
		const result = yield call(workHours, token);
                          
		if (result && result.listarTiposHoraTrabalho) {
            yield put({ type: "SET_WORK_HOUR_TYPE_LIST", payload: result.listarTiposHoraTrabalho});
        }
	} catch (error) {
		log.info(error);
	}
}

function* createNewPreScheduling(payload) {
	try {
        yield put({ type: "SET_PRE_SCHEDULING_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(newPreScheduling, payload.payload, token);

		if (result && result.data && result.data.criarPreAgendamento) {
            yield put({ 
                type: "SET_PRE_SCHEDULING_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].registerSuccess,
                    messageType: "toast-success"
                }});

            yield put({ type: 'SET_GET_PRE_SCHEDULING', payload: result.data.criarPreAgendamento.id });
        } else {
			yield put({ 
				type: "SET_PRE_SCHEDULING_TOAST", 
				payload: {
					showToast: true,
					message: result.errors ? result.errors[0].message : messages[lang].registerError,
					messageType: "toast-error"
				}});
        }

        yield put({ type: "SET_PRE_SCHEDULING_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getPreSchedulingDetails(payload) {
	try {
        yield put({ type: "SET_PRE_SCHEDULING_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

		const result = yield call(preSchedulingDetails, payload.payload, token);

		if (result && result.buscarPorId) {
            yield put({ type: "SET_FETCHED_PRE_SCHEDULING_DETAILS", payload: result.buscarPorId});
        }

        yield put({ type: "SET_PRE_SCHEDULING_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* editPreSchedulingDetails(payload) {
	try {
        yield put({ type: "SET_PRE_SCHEDULING_LOADING", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);
        
		const result = yield call(editPreScheduling, payload.payload, token);

		if (result.data && result.data.atualizarPreAgendamento) {
            yield put({ 
                type: "SET_PRE_SCHEDULING_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].registerSuccess,
                    messageType: "toast-success"
                }});
        } else {
			yield put({ 
				type: "SET_PRE_SCHEDULING_TOAST", 
				payload: {
					showToast: true,
					message: result.errors ? result.errors[0].message : messages[lang].registerError,
					messageType: "toast-error"
				}});
        }

        yield put({ type: "SET_PRE_SCHEDULING_LOADING", payload: false });
	} catch (error) {
		log.info(error);
	}
}

const preSchedulingReportFromApi = ( token, payload) => {
	const {
        nomeFornecedor,
        cnpjFornecedor,
        nomeCd,
        nomeEmpresa,
        ativo
	 } = payload.filters

	const urlFilters = 
		'nomeEmpresa=' + nomeEmpresa + 
		addFilter(nomeCd, 'nomeCd') +
		addFilter(nomeFornecedor, 'nomeFornecedor') +
        addFilter(cnpjFornecedor, 'cnpjFornecedor') +
		addFilter(ativo, 'ativo')
		
	return requestDefaultJson({
		method: "GET",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/relatorios/Reports/preagendamento.pdf?' + urlFilters,
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_REPORT"),
			"Authorization": token
		},
		responseType: 'blob'
	});
};

function* preSchedulingReportFromApiCSV(token, payload) {
	try {
        const {
            nomeFornecedor,
            cnpjFornecedor,
            nomeCd,
            nomeEmpresa,
            ativo
         } = payload.filters

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PRE_AGENDAMENTO"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`
                query {
                    listarPreAgendamentosRelatorio(
                        nomeFornecedor: "${nomeFornecedor}"
                        cnpjFornecedor: "${cnpjFornecedor}"
                        nomeCd: "${nomeCd}"
                        nomeEmpresa: "${nomeEmpresa}"
                        ativo: "${ativo}"
                    ) {
                        id
                        descricao
                        dataCadastro
                        dataModificacao
                        capacidade
                        transferencia
                        recebimentoDeEncabidado
                        recebimentoCaixaria
                        fornecedor
                        cd
                        empresa
                        ativo
                        dataInicial
                        dataFinal
                        horaInicial
                        horaFinal
                        tipoHoraTrabalho
                        agendaFixa
                    }
                }
            `
		};

		const { data } = yield call(preSchedulingFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* getSchedulingReport(payload) {
	try {
		yield put({ type: "SET_LOADING_PRE_SCHEDULING_REPORT", payload: true });

		const { token } = yield select(state => state.authentication)

		let data = yield call(preSchedulingReportFromApi, token, payload.payload);

		saveAs(data, `relatorio_pre_agendamento.pdf`);
		
		yield put({ type: "SET_LOADING_PRE_SCHEDULING_REPORT", payload: false });
	} catch (error) {
		yield put({ type: "SET_LOADING_PRE_SCHEDULING_REPORT", payload: false });
		log.info(error);
	}
}

function* getCSVSchedulingReport(payload) {
	try {
		yield put({ type: "SET_LOADING_PRE_SCHEDULING_REPORT", payload: true });

		const { token } = yield select(state => state.authentication)

		let data = yield call(preSchedulingReportFromApiCSV, token, payload.payload);

		yield put({ type: "SET_CSV_PRE_SCHEDULING_REPORT", payload: data && data.listarPreAgendamentosRelatorio });
		
		yield put({ type: "SET_LOADING_PRE_SCHEDULING_REPORT", payload: false });
	} catch (error) {
		yield put({ type: "SET_LOADING_PRE_SCHEDULING_REPORT", payload: false });
		log.info(error);
	}
}

// Generator function
export function* preSchedulingWatcher() {
    yield takeLatest("GET_PROVIDER_PRE_SCHEDULING_LIST", getProviderPreSchedulingList);
    yield takeLatest("GET_TIME_ZONES", getTimeZones);
    yield takeLatest("GET_WORK_HOUR_TYPES", getWorkHourTypes);
    yield takeLatest("CREATE_NEW_PRE_SCHEDULING", createNewPreScheduling);
    yield takeLatest("GET_PRE_SCHEDULING_DETAILS", getPreSchedulingDetails);
    yield takeLatest("EDIT_PRE_SCHEDULING_DETAILS", editPreSchedulingDetails);
    yield takeLatest("GET_PRE_SCHEDULING_REPORT", getSchedulingReport);
	yield takeLatest("GET_CSV_PRE_SCHEDULING_REPORT", getCSVSchedulingReport);
}